import ModelLoader from './ModelLoader2';

export default ModelLoader;